import PropTypes from 'prop-types';
import { color } from "../styles/theme";
import { fade } from "../utils/colorUtils"; // Shared by components that have a box-shadow, e.g. Paper, Card, DropDownList, etc.

export var Z_DEPTH_SHADOWS = [[1, 1, 0.1, 1, 2, 0.12], [1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22]].map(function (d) {
  return "0 ".concat(d[0], "px ").concat(d[1], "px ").concat(fade(color.black, d[2]), ",\n   0 ").concat(d[3], "px ").concat(d[4], "px ").concat(fade(color.black, d[5]));
}); // A11y-related focus constants

export var FOCUS_DIRECTION = {
  previous: 'previous',
  next: 'next'
}; // Api status

export var API_BEFORE_SEND = 'API_BEFORE_SEND';
export var API_IN_PROGRESS = 'API_IN_PROGRESS';
export var API_SUCCESS = 'API_SUCCESS';
export var API_ERROR = 'API_ERROR';
export var apiStatusPropType = PropTypes.oneOf([API_BEFORE_SEND, API_IN_PROGRESS, API_ERROR, API_SUCCESS]); // TODO(Audrey): add more structured error PropTypes later

export var errorPropType = PropTypes.object;
export var FULL_NAME_MIN_LEN = 1;
export var FULL_NAME_MAX_LEN = 254;
export var EMAIL_MIN_LEN = 3;
export var EMAIL_MAX_LEN = 254;
export var PASSWORD_MIN_LEN = 8;
export var PASSWORD_MAX_LEN = 128;
export var INPUT_DEBOUNCE_TIME = 200;